import React from 'react';
import BottomSheet from '../components/BottomSheet/BottomSheet';
import Button from '../components/Button/Button';
import ProductDetailContent, { ProductDetailProduct } from '../components/ProductDetailContent/ProductDetailContent';
import './ProductDetailBottomSheet.css';

interface ProductDetailBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onBack?: () => void;
  product: ProductDetailProduct;
  onAddProduct?: (productId: number) => void;
}

const ProductDetailBottomSheet: React.FC<ProductDetailBottomSheetProps> = ({
  isOpen,
  onClose,
  onBack,
  product,
  onAddProduct,
}) => {
  const handleAddProduct = () => {
    onAddProduct?.(Number(product.product_id));
    onClose();
  };

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title="Product Details"
      height="85vh"
      className="product-detail-bottom-sheet"
    >
      <div className="product-detail-sheet-inner">
        <div className="product-detail-sheet-scroll">
          <ProductDetailContent product={product} />
        </div>

        {onAddProduct && (
          <div className="product-detail-footer">
            <Button
              variant="primary"
              onClick={handleAddProduct}
              className="full-page-button"
            >
              Add Product
            </Button>
          </div>
        )}
      </div>
    </BottomSheet>
  );
};

export default ProductDetailBottomSheet;
